<template>
  <div @click="selected" class="cursor-pointer">
    <p class="mb-2"><b>/{{message.attributes.label}}</b></p>
    <p>{{message.attributes.text}}</p>
  </div>
</template>


<script>

export default {
  name: 'CannedMessage',
  props: ['message'],
  emits: ['template-selected'],
  methods: {
    selected() {
      this.$emit('template-selected', this.message);
    },
  },
}
</script>
